// iOS Safari (and Android Chrome) don't tell fixed-position elements about
// the software keyboard. The layout viewport stays the same size while the
// visual viewport shrinks — so bottom: 0 elements get hidden under the
// keyboard. We use the visualViewport API to size the chat page to the
// actually-visible area, which pushes the composer above the keyboard
// automatically.
import { useEffect, useState } from "react";

function currentHeight() {
  if (typeof window === "undefined") return 800;
  if (window.visualViewport) return window.visualViewport.height;
  return window.innerHeight;
}

export function useVisualViewportHeight() {
  const [h, setH] = useState(currentHeight);

  useEffect(() => {
    const update = () => setH(currentHeight());
    // Fires on keyboard show/hide and orientation change.
    if (window.visualViewport) {
      window.visualViewport.addEventListener("resize", update);
      window.visualViewport.addEventListener("scroll", update);
    }
    window.addEventListener("resize", update);
    window.addEventListener("orientationchange", update);
    update();
    return () => {
      if (window.visualViewport) {
        window.visualViewport.removeEventListener("resize", update);
        window.visualViewport.removeEventListener("scroll", update);
      }
      window.removeEventListener("resize", update);
      window.removeEventListener("orientationchange", update);
    };
  }, []);

  return h;
}
